/**
 * 优惠券
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/1/19      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import PropTypes from "prop-types";
import {Button} from "antd";
import "./index.less"
import CouponCountDown from "@components/Coupon/coupon-count-down";
import CommonCoupon from "@components/Coupon/common-coupon";
import {getTip,goodsRangeType,getTime,} from "@components/Coupon/common";
class Coupon extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        const {item} = this.props;
        const isDisabled = (item.isUse||item.status=='expire')?true:false;
        // let remainSeconds = (item.effectiveEndTime - item.effectiveStartTime)/1000;
        return (
            <div className={`antd-coupon-card-wrap ${isDisabled?'disabled':''}`}>
                <div className="antd-coupon-card">
                    {
                        isDisabled?
                            <span className="label">{__getServerLanguage('BuKeShiYong')}</span>
                            :
                            <span>
                                {
                                    item.isPrepareExpire===1?
                                        <span className="label">
                                            <CouponCountDown item={item} remainingDays={item.remainingDays}></CouponCountDown>
                                        </span>:
                                        null
                                }
                            </span>

                    }
                    <div className="hd">
                        <div>
                            <CommonCoupon item={item}></CommonCoupon>
                        </div>
                        <div className="tip">
                            {getTip(item)}
                        </div>
                    </div>
                    <div className="round-wrap">
                        <span className="round"></span>
                        <span className="round"></span>
                    </div>

                    {
                        item.goodsRangeType !== 'brand'?
                            <div>
                                <div className="content">
                                    <div>{goodsRangeType(item)}</div>
                                    <div>{getTime(item)}</div>
                                </div>
                                <div className="intro">
                                    <div>{__getServerLanguage('ShiYongShuoMing')}：</div>
                                    <div className="intro-instructions">
                                        {item.instructions||'-'}
                                    </div>
                                </div>
                            </div>
                            :
                            <div>
                                <div className="content2">
                                    <img className="img" src={item.brandUrl?item.brandUrl+'@!100':'/assets/img/logo.png'}  alt=""/>
                                    <div>
                                        <div className="brand-name">
                                            {item.brandName}
                                        </div>
                                        <div className="content2-tip">
                                            <p>{goodsRangeType(item)}</p>
                                            <p>{getTime(item)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="intro">
                                    <div>{__getServerLanguage('ShiYongShuoMing')}：</div>
                                    <div className="intro-instructions2">
                                        {item.instructions||'-'}
                                    </div>
                                </div>
                            </div>

                    }
                    <div className="btn-wrap">
                        {/*过期*/}
                        {
                            item.status=='expire'&&!item.isUse?
                                <Button disabled ghost shape="round" disabled={true}>{__getServerLanguage('YiGuoQi')}</Button>
                                :
                                null
                        }
                        {/*已使用*/}
                        {
                            (item.status=='expire'||item.status=='effective')&&item.isUse?
                                <Button disabled ghost shape="round" disabled={true}>{__getServerLanguage('YiShiYong')}</Button>
                                :
                                null
                        }
                        {/*可使用*/}
                        {/*{*/}
                            {/*item.status=='effective'&&!item.isUse?*/}
                                {/*<Button href={getLink(item)} type="danger" ghost shape="round">{__getServerLanguage('QuShiYong')}</Button>*/}
                                {/*:*/}
                                {/*null*/}
                        {/*}*/}
                        {/*待生效 href={getLink(item)} */}
                        {
                            item.status=='to_be_effective'&&item.link?
                                <Button  type="danger" ghost shape="round">{__getServerLanguage('QuShiYong')}</Button>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

Coupon.defaultProps = {
    item:{}
}

Coupon.propTypes = {

}
export default Coupon;
